var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Shipping","lazy":""}},[_c('shipping-tab')],1),_c('b-tab',{attrs:{"title":"Receiving","lazy":""}},[_c('receiving-tab')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }